// extracted by mini-css-extract-plugin
module.exports = {"youtubeHolder":"styles_youtubeHolder__Ia0dt","youtubeVideo":"styles_youtubeVideo__ASRW5"};